/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { pgTable, serial, text, integer, timestamp } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';

/**
 * Processing jobs table - tracks overall processing operations
 */
export const processingJobs = pgTable("processing_jobs", {
  id: text("id").primaryKey(),
  operationType: text("operation_type").notNull(),
  status: text("status").notNull(), // processing, completed, error
  progress: integer("progress").default(0),
  result: text("result"), // JSON string
  error: text("error"),
  totalItems: integer("total_items").default(0),
  completedItems: integer("completed_items").default(0),
  errorItems: integer("error_items").default(0),
  startedAt: timestamp("started_at"),
  completedAt: timestamp("completed_at"),
  createdAt: timestamp("created_at").defaultNow(),
  updatedAt: timestamp("updated_at").defaultNow(),
});

/**
 * Processing items table - tracks individual items within a processing job
 */
export const processingItems = pgTable("processing_items", {
  id: serial("id").primaryKey(),
  processingId: text("processing_id").notNull(),
  itemId: text("item_id").notNull(),
  name: text("name").notNull(),
  status: text("status").notNull(), // pending, processing, completed, error
  progress: integer("progress").default(0),
  error: text("error"),
  url: text("url"),
  size: text("size"),
  contentId: integer("content_id"),
  startedAt: timestamp("started_at"),
  completedAt: timestamp("completed_at"),
  createdAt: timestamp("created_at").defaultNow(),
  updatedAt: timestamp("updated_at").defaultNow(),
});

/**
 * Content processing mappings table - maps content to processing jobs
 */
export const contentProcessingMappings = pgTable("content_processing_mappings", {
  id: serial("id").primaryKey(),
  contentId: integer("content_id").notNull(),
  processingId: text("processing_id").notNull(),
  operationType: text("operation_type").notNull(),
  createdAt: timestamp("created_at").defaultNow(),
}); 